import script from "./RangeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeInput.vue?vue&type=script&setup=true&lang=js"

import "./RangeInput.vue?vue&type=style&index=0&id=c975ba8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c975ba8e"]])

export default __exports__